import { SalesOrderStatusItem } from './sales-order-status-item';
import { SalesOrderLineValue } from './sales-order-line-value';
import { OrderAgent } from './order-agent';
import { SalesOrderDocumentStatusItem } from './sales-order-document-status-item';

export interface SalesOrderHeaderDetails {
  id: string;
  orderNo: string;
  customerKey: string;
  customerName: string;
  customerId: string;
  customerCountryId: string;
  customerPostcode: string;
  customerContactId: string;
  customerOrderNo: string;
  customerOrderRef: string;
  dateOrdered: Date;
  dateEntered: Date;
  confirmationPrinted: boolean;
  orderSourceId: string;
  orderTypeId: string;
  orderStatusId: string;
  creditPassed: boolean;
  creditPassedBy: string;
  creditPassedDate: Date;
  customerAddressMultiLine: string;
  paymentTermId: string;
  currencyId: string;
  settlementTermId: string;
  sellingCompanyId: string;
  taxId: string;
  vatRegNo: string;
  proformaPaid: boolean;
  serviceRepId: string;
  bankId: string;
  proformaOrder: boolean;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  invoiceAddressId: string;
  invoiceAddressMultiLine: string;
  shipperSupplierId: string;
  portId: string;
  modeOfTransportId: string;
  deliveryTermId: string;
  chargeDelivery: boolean;
  orderLineValue: number;
  discountValue: number;
  deliveryItemValue: number;
  extraItemValue: number;
  nettValue: number;
  taxValue: number;
  overallValue: number;
  invoiceFromPicking: boolean;
  autoCreatePurchaseOrder: boolean;
  allocateFromWarehouseId: string;
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  deliveryCountryId: string;
  deliveryPostcode: string;
  invoiceAddresseeId: string;
  invoiceAddressee: string;
  orderSource: string;
  orderType: string;
  orderStatus: string;
  paymentTerm: string;
  currency: string;
  settlementTerm: string;
  sellingCompany: string;
  tax: string;
  serviceRep: string;
  bank: string;
  shipperSupplier: string;
  port: string;
  modeOfTransport: string;
  deliveryTerm: string;
  webOrderInvoiceNumber: number;
  webOrderInvoiceDate: Date;
  webOrderPaymentMethodId: string;
  webOrderPaymentMethod: string;
  customerTradeGroup: string;
  salesDiscount: string;
  salesOrderConfirmed: boolean;
  salesOrderConfirmedString: string;
  pickingListPrinted: boolean;
  pickingListDate: Date;
  pickingListPrintedBy: string;
  canDelete: boolean;

  salesOrderStatusItems: SalesOrderStatusItem[];
  salesOrderDocumentStatusItems: SalesOrderDocumentStatusItem[];
  salesOrderLineValues: SalesOrderLineValue[];
  orderAgents: OrderAgent[];
}
